export default {
  apiDangerErrors: state => {
    return state.apiErrors == null ? null : state.apiErrors.danger
  },
  apiWarningErrors: state => {
    return state.apiErrors == null ? null : state.apiErrors.warning
  },
  apiInfoErrors: state => {
    return state.apiErrors == null ? null : state.apiErrors.info
  },
  apiOtherErrors: state => {
    if (state.apiErrors == null) {
      return null
    }

    let errors = []
    let apiErrors = state.apiErrors

    for (var prop in apiErrors) {
      if (!apiErrors.hasOwnProperty(prop)) {
        continue
      }

      if (prop === 'danger' || prop === 'warning') {
        continue
      }

      let currentErrors = apiErrors[prop]
      for (let i = 0; i < currentErrors.length; i++) {
        errors.push('[' + prop + '] - ' + currentErrors[i])
      }
    }

    return errors
  }
}
